export default {
  level: 'Nivel',
  total: 'Total',
  planLevel: 'Nivel del Plan',
  quantityOf: 'Cantidad de',
  definition: 'Definición',
  description: 'Descripción',
}
